import { NgModule } from '@angular/core';
import { PreloadingStrategy, Route, RouterModule, Routes } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthGuard } from './guard/auth.guard';
// import { PromoteResolver } from './resolvers/promote.resolver';

class PreloadSelectedModules implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        return route.data?.['preload'] ? load() : of(null);
    }
}

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    },

    {
        path: 'app-connect',
        loadChildren: () => import('./app-connect/app-connect.module').then((m) => m.AppConnectModule),
    },

    {
        path: '',
        // resolve: [PromoteResolver],
        canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: '/dashboard', pathMatch: 'full' },

            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
                data: { preload: true },
            },

            {
                path: 'edit-account',
                loadChildren: () => import('./edit-account/edit-accout.module').then((m) => m.EditAccoutModule),
                data: { preload: true },
            },

            {
                path: ':eventId',
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./customer/customer.module').then((m) => m.CustomerModule),
                        data: { preload: true },
                    },
                    {
                        path: 'tickets',
                        loadChildren: () => import('./tickets/tickets.module').then((m) => m.TicketsModule),
                    },
                    {
                        path: 'event-feedback',
                        loadChildren: () => import('./event-feedback/event-feedback.module').then((m) => m.EventFeedbackModule),
                    },
                    {
                        path: 'causes',
                        loadChildren: () => import('./causes/causes.module').then((m) => m.CausesModule),
                    },
                    {
                        path: 'invitees',
                        loadChildren: () => import('./invitee/invitee.module').then((m) => m.InviteeModule),
                    },
                    {
                        path: 'report',
                        loadChildren: () => import('./report/report.module').then((m) => m.ReportModule),
                    },
                    {
                        path: 'basic-info',
                        loadChildren: () => import('./basic-info/basic-info.module').then((m) => m.BasicInfoModule),
                    },
                ],
            },
            {
                path: ':customerId/:eventId',
                loadChildren: () => import('./customer/customer.module').then((m) => m.CustomerModule),
            },
            {
                path: ':appId/:eventId',
                loadChildren: () => import('./build/build.module').then((m) => m.BuildModule),
            },
        ],
    },

    // {
    //     path: ':eventId',
    //     canActivate: [AuthGuard],
    //     loadChildren: () => import('./customer/customer.module').then((m) => m.CustomerModule),
    // },

    {
        path: ':customerId/:eventId',
        // resolve: [PromoteResolver],
        loadChildren: () => import('./register/register.module').then((m) => m.RegisterModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadSelectedModules,
            scrollPositionRestoration: 'enabled',
        }),
    ],
    providers: [PreloadSelectedModules],
    exports: [RouterModule],
})
export class AppRoutingModule {}
